import { useState } from "react";
import { LuRefreshCw } from "react-icons/lu";
import { PiFlashlight } from "react-icons/pi";

const CameraControls = ({ onSwitchCamera, cameraStream }) => {
    const [isFlashlightOn, setIsFlashlightOn] = useState(false);
    const [isSwitching, setIsSwitching] = useState(false);

    const handleSwitchCamera = async () => {
        if (isSwitching) return;
        setIsSwitching(true);
        try {
            await onSwitchCamera();
        } catch (error) {
            console.error('Error switching camera:', error);
        } finally {
            setTimeout(() => setIsSwitching(false), 500);
        }
    };

    const handleToggleFlashlight = async () => {
        try {
            if (cameraStream) {
                const videoTrack = cameraStream.getVideoTracks()[0];
                const capabilities = videoTrack.getCapabilities();

                if (capabilities.torch) {
                    await videoTrack.applyConstraints({
                        advanced: [{ torch: !isFlashlightOn }]
                    });
                    setIsFlashlightOn(!isFlashlightOn);
                } else {
                }
            }
        } catch (error) {
            console.error('Error toggling flashlight:', error);
        }
    };

    return (
        <div className="absolute top-14 right-0 p-2 z-20">
            <div
                className={`h-8 w-8 rounded-full bg-black/50 border border-white flex items-center justify-center cursor-pointer mb-2 hover:bg-black/70 transition-all ${isSwitching ? 'opacity-50' : ''
                    }`}
                onClick={handleSwitchCamera}
                title="Switch Camera"
            >
                <LuRefreshCw className={`text-[18px] text-white ${isSwitching ? 'animate-spin' : ''
                    }`} />
            </div>
            <div
                className={`h-8 w-8 rounded-full border border-white flex items-center justify-center cursor-pointer hover:bg-black/70 transition-all ${isFlashlightOn ? 'bg-yellow-500/70' : 'bg-black/50'
                    }`}
                onClick={handleToggleFlashlight}
                title="Toggle Flashlight"
            >
                <PiFlashlight className={`text-[18px] ${isFlashlightOn ? 'text-yellow-200' : 'text-white'
                    }`} />
            </div>
        </div>
    );
};

export default CameraControls;